import { setLocale } from '@shared-core/features/settings/slice'
import { createAsyncThunk } from '@shared-core/store/utils'

export const setDefaultLang = createAsyncThunk(
  'settings/setDefaultLang',
  (params: { locale: string; localeISO: string }, api): void => {
    const { dispatch } = api
    const { locale, localeISO } = params

    if (locale && localeISO) {
      dispatch(setLocale({ locale, localeISO }))
    }
  },
)
